import { baseCMSApi } from '@/shared/api/base-cms-api';
import { CMS_ENDPOINTS } from '@/shared/api/endpoints';

import type { Disclamers } from '../model/types/disclamers';

const disclamersApi = baseCMSApi
    .enhanceEndpoints({
        addTagTypes: ['Disclamers'],
    })
    .injectEndpoints({
        endpoints: (build) => ({
            getDisclamersContent: build.query<Disclamers, { locale: string }>({
                query: (params) => ({
                    url: CMS_ENDPOINTS.getDisclamers(),
                    method: 'GET',
                    params: {
                        locale: params.locale,
                        depth: 1,
                    },
                }),
                providesTags: ['Disclamers'],
            }),
        }),
    });

export const { useGetDisclamersContentQuery } = disclamersApi;
